import { useState } from "react";
import "./style.css";

interface RatingProps {
  starSelected: number;

  setStarSelected(starSelected: number): void;
}

const Rating = ({ starSelected, setStarSelected }: RatingProps) => {
  const [hover, setHover] = useState(0);

  return (
    <div className="boxRating">
      <button
        type="button"
        className="starButton"
        onClick={() => setStarSelected(1)}
        onMouseEnter={() => setHover(1)}
        onMouseLeave={() => setHover(0)}
      >
        <img
          src={
            (starSelected >= 1 && "/rating-selected.svg") ||
            (hover >= 1 && "/rating-hover.svg") ||
            "/rating-void.svg"
          }
          alt="1"
        />
      </button>
      <button
        type="button"
        className="starButton"
        onClick={() => setStarSelected(2)}
        onMouseEnter={() => setHover(2)}
        onMouseLeave={() => setHover(0)}
      >
        <img
          src={
            (starSelected >= 2 && "/rating-selected.svg") ||
            (hover >= 2 && "/rating-hover.svg") ||
            "/rating-void.svg"
          }
          alt="2"
        />
      </button>
      <button
        type="button"
        className="starButton"
        onClick={() => setStarSelected(3)}
        onMouseEnter={() => setHover(3)}
        onMouseLeave={() => setHover(0)}
      >
        <img
          src={
            (starSelected >= 3 && "/rating-selected.svg") ||
            (hover >= 3 && "/rating-hover.svg") ||
            "/rating-void.svg"
          }
          alt="3"
        />
      </button>
      <button
        type="button"
        className="starButton"
        onClick={() => setStarSelected(4)}
        onMouseEnter={() => setHover(4)}
        onMouseLeave={() => setHover(0)}
      >
        <img
          src={
            (starSelected >= 4 && "/rating-selected.svg") ||
            (hover >= 4 && "/rating-hover.svg") ||
            "/rating-void.svg"
          }
          alt="4"
        />
      </button>
      <button
        type="button"
        className="starButton"
        onClick={() => setStarSelected(5)}
        onMouseEnter={() => setHover(5)}
        onMouseLeave={() => setHover(0)}
      >
        <img
          src={
            (starSelected === 5 && "/rating-selected.svg") ||
            (hover === 5 && "/rating-hover.svg") ||
            "/rating-void.svg"
          }
          alt="5"
        />
      </button>
    </div>
  );
};

export default Rating;
